module.exports = __webpack_public_path__ + "static/logowhite-36a8a87b58f93447bed221ecc7d81055.svg";